
import * as Validation from './../general/Validation.js';
import MyLocalStorage from './../general/LocalStorage';

import * as Errors from './../general/Error.js';

import {getLibPhoneNumber,parsePhoneNumber} from './../general/PhoneHelper';
import $ from "jquery";

class ClickAndReserveForm {

	isRequestRunning = false;

	constructor( containerEl ) {

		this.$container = $( containerEl );

		// Add Navigation.
		this.$container.on( 'click', '.reserveButton', ( ev ) => this.showForm( ev.target ) );
		this.$container.on( 'click', '.mdl_stock_reserve__form_button_back', ( ev ) => this.hideForm() );

		// Add Formsubmit.
		this.$container.on( 'submit', '.mdl_stock_reserve__form', ( ev ) => this.onSubmit( ev ) );

		// Add stuff for libphonenumber, if not already happened.
		this.$container.on( 'popup_open.en', () => getLibPhoneNumber() );
		this.$container.on( 'focusout', '.mdl_stock_reserve__form input[type="tel"]', ( ev ) => this.formatPhoneNumber( ev.target ) );

		// Add Input validation.
		this.$container.on( 'change input', '.mdl_stock_reserve__form input[data-validate]', ( ev ) => this.validateInput( ev.target ) );
		this.$container.on( 'focusout', '.mdl_stock_reserve__form input[data-validate]', ( ev ) => this.validateInput( ev.target, true ) );

	}

	reset() {
		this.hideForm();
	}

	showForm( button ) {

		this.setLoading( false );

		// Update input so we can identify the product.
		this.$container.find( '#identnummer' ).val( button.value );

		// Set Size Header.
		const size = $( button ).closest( '.table_row' ).find( '.sizebutton' ).text();
		this.setSizeHeader( size );

		// Hide all colors after a size has been chosen
		this.toggleColorInputs( false );

		// Pre-Fill Form Data.
		this.setFormData( true );

		// Hide Table and show Form.
		EN_KO.functions.toggleSlide( this.$container.find( '.mdl_stock_reserve__matrix' ), false );
		EN_KO.functions.toggleSlide( this.$container.find( '.mdl_stock_reserve__form' ), true );

	}

	hideForm() {

		// Set Size Header.
		this.setSizeHeader( false );

		// Show Colors again.
		this.toggleColorInputs( true );

		// Reset Form Data.
		this.setFormData( false );

		// Show Table and hide Form.
		EN_KO.functions.toggleSlide( this.$container.find( '.mdl_stock_reserve__matrix' ), true );
		EN_KO.functions.toggleSlide( this.$container.find( '.mdl_stock_reserve__form' ), false );
	}

	showFinish() {

		// Reset Form Data.
		this.setFormData( false );

		// Hide Form and show done window.
		EN_KO.functions.toggleSlide( $( '.mdl_stock_reserve__done' ), true );
		EN_KO.functions.toggleSlide( $( '.mdl_stock_reserve__matrix' ), false );
		EN_KO.functions.toggleSlide( $( '.mdl_stock_reserve__form' ), false );
		EN_KO.functions.toggleSlide( $( '.mdl_stock_reserve__header' ), false );
	}

	setSizeHeader( size ) {

		const $header = this.$container.find( '.mdl_stock_reserve__article_size' );
		const $label = $header.find( '.mdl_stock_reserve__article_size_label' );
		const $value = $header.find( '.mdl_stock_reserve__article_size_value' );

		if ( size ) {

			// Show size in textlabel.
			$label.html( 'Größe:' );
			$value.html( size );
			$header.removeClass( 'en_hidden' );

		} else {

			// Clear text and hide container.
			$label.text( '' );
			$value.text( '' );
			$header.addClass( 'en_hidden' );
		}
	}

	toggleColorInputs( display = true ) {

		const $choices = this.$container.find( '.acl_js--color_choice_input' ).parent();

		if ( display ) {

			// Show all Color Choices.
			$choices.removeClass( 'en_hidden' );

		} else {

			// Hide all other colors after a size has been chosen.
			$choices.filter( function() {
				return ! $( this ).find( '.acl_js--color_choice_input' ).is( ':checked' );
			} ).addClass( 'en_hidden' );
		}

		// Recalculate layout from parent container.
		$choices.closest( '.acl_js--color_choices_container' ).trigger( 'recalculate.en' );
	}

	setFormData( fillForm = true ) {

		if ( fillForm ) {
			try {
				const data = JSON.parse( MyLocalStorage.getItem( 'FMR' ) );
				const keys = [
					'salutation',
					'firstname',
					'surname',
					'email',
					'notify_by_sms',
					'phone'
				];

				// No Data - nothing to do.
				if ( ! data ) {
					return;
				}

				keys.forEach( ( key ) => {
					var val = data[ key ];

					if ( ! val ) {
						return;
					}

					const $input = this.$container.find( '.mdl_stock_reserve__form :input' ).filter( function() {
						return $( this ).attr( 'name' ) === 'reserve[' + key + ']';
					} );

					switch ( key ) {

						case 'notify_by_sms':
							$input.filter( function() {
								return $( this ).val() === val;
							} ).click();
							break;

						default:
							$input.val( val );
							break;
					}
				} );
			} catch ( ex ) {
				console.error( ex );
			}
		} else {

			// Reset Form.
			this.$container.find( '.mdl_stock_reserve__form' ).get( 0 ).reset();
		}
	}

	formatPhoneNumber( input ) {

		const $input = $( input );

		const isValid = this.validateInput( $input, true );
		console.log( isValid );
		if ( ! isValid ) {
			return;
		}

		const parsed = window.libphonenumber.parsePhoneNumberFromString( $input.val() );
		if ( ! parsed ) {
			return;
		}
		$input.val( parsed.formatInternational() );
	}

	validateForm() {

		const $form = this.$container.find( '.mdl_stock_reserve__form' );
		const $inputs = $form.find( 'input[data-validate]' );

		return $inputs.toArray().map( ( input ) => this.validateInput( input, true ) ).every( isValid => isValid );
	}

	validateInput( selector, displayValidation = false ) {

		const $el = $( selector );
		const $form = this.$container.find( '.mdl_stock_reserve__form' );

		// Whether to display any validation at all.
		if ( displayValidation ) {
			$el.data( 'displayValidation', true );
		}

		// Remove previous errors ( if errors are active )
		if ( $el.data( 'displayValidation' ) ) {
			Errors.hideError( $el );
		}

		// Validation Group.
		const validGroup = $el.attr( 'data-validate-grp' ) || false;

		// Inputs that are part of an input group get validated together.
		const $inputs = validGroup ? $form.find( 'input[data-validate]' ).filter( function() {
			return $( this ).attr( 'data-validate-grp' ) === validGroup;
		} ) : $el;

		// Validate all Inputs in the group and return their status.
		const inputStati = $inputs.toArray().map( function( inputEl ) {

			const $input = $( inputEl );

			// Get Validation Handler functions
			const validFuncName = $input.data( 'validate' );
			const validFuncArgs = $input.data( 'validate-args' ) || [];
			const validateFn = Validation[ validFuncName ];

			// Disabled Inputs are always valid.
			if ( $input.is( ':disabled' ) ) {
				return true;
			}

			// Skip Validation while this is not set.
			if ( ! $input.data( 'displayValidation' ) ) {
				return true;
			}

			// Get values and infos.
			const value = $input.val() || '';

			// Check required.
			if ( $input.hasClass( 'required' ) && ! Validation.checkLength( value ) ) {
				return false;
			}

			if ( inputEl.type === 'text' && ! Validation.validInputCharacters( value ) ) {
				return false;
			}

			// Check with custom function, if available.
			if ( typeof validateFn === 'function' ) {

				// Fill arguments and allow custom args.
				const args = [ value ].concat( [].concat( validFuncArgs ).map( ( arg ) => arg.split( ',' ) ) );

				// Apply validationFN and return result.
				// E.g. validName() or validEmail()
				return validateFn.apply( this, args );
			}

			return true;
		} );

		// Reduce results to a single one.
		const isValid = inputStati.reduce( ( prev, isValid ) => {
			if ( typeof isValid === 'string' || ! isValid ) {
				return isValid;
			}

			return prev;
		} );

		if ( typeof isValid === 'string' || ! isValid ) {

			// Custom Error Handler.
			const handleError = $el.data( 'error-handle' ) || false;

			if ( handleError && typeof window[ handleError ] === 'function' ) {
				const message = window[ handleError ].apply( $el, [ isValid ] ) || false;
				Errors.showError( $el, message );
			} else {
				Errors.showError( $el );
			}

			// An Error occured - not valid.
			return false;
		}

		// No Error occured.
		return true;
	}

	isLoading() {
		return this.isRequestRunning;
	}

	setLoading( state ) {

		// Set Loading to true or false.
		const $button = this.$container.find( '#submitReservation' );
		$button.toggleClass( 'en_button--loading', state );
		this.isRequestRunning = state;
	}

	onSubmit( ev ) {

		// This Form only works via AJAX.
		ev.preventDefault();

		// There already is a request running. No multi-submits.
		if ( this.isLoading() ) {
			return;
		}

		// Can't submit an invalid form.
		if ( ! this.validateForm() ) {
			return;
		}

		// Get ID of selected subsidiary.
		const subsidiaryId = this.$container.find( '#shipping-location-select option:selected' ).attr( 'data-attr-subsidiary-id' );

		// Add subsidiary to FormData.
		const formData = $( ev.target ).serializeJSON();
		formData['subsidiaryId'] = subsidiaryId;

		// This request may only run one time at once.
		this.setLoading( true );

		const url = '/index.php?cl=searchservice_oxwarticledetails&fnc=reserveProduct';
		$.ajax( {
			method: 'POST',
			url: url,
			data: formData,
			complete: ( response ) => {
				if ( response.responseText === 'success' ) {

					// Save the values for later reuse.
					MyLocalStorage.setItem( 'FMR', JSON.stringify( formData.reserve ) );

					// Trigger Event.
					$( document ).trigger( 'mdl_quickview_reservation_done.en' );
					window.dispatchEvent( new CustomEvent( 'mdl_quickview_reservation_done.en' ) );

					const spec = 'ClickAndReserve';
					const email =  $( '#account_reservation_53_email' ).val();
					const event = $( 'title' ).text().trim();

					window.TAO_KOE.Tracking.sendIdentifyEvent( spec, email, event );

					// Hide Form and show next step.
					this.showFinish();

				} else {
					 const parsed = JSON.parse( response.responseText );

					if ( typeof parsed.data.error === 'string' ) {

						// This should usually never happen - but we will still push the info to the user
						if ( window.TAO_KOE && window.TAO_KOE.Toaster )  {
							window.TAO_KOE.Toaster.toast( parsed.data.error, 'error' );
						} else {
							alert( parsed.data.error );
						}

					} else if ( Array.isArray( parsed.data.error ) ) {

						parsed.data.error.forEach( ( err ) => {
							if ( typeof err.name !== 'undefined' ) {
								if ( err.name.toLowerCase() === 'email' ) {

									const $email = $( '#account_reservation_53_email' );
									Errors.showError( $email, err.message );
								}
								if ( err.name.toLowerCase() === 'phone' ) {

									const $phone = $( '#account_reservation_53_phone' );
									Errors.showError( $phone, err.message || window.handleMobileError( err.error ) );
								}
							}
						} );
					}
				}
			}
		} )
			.promise()
			.always( () => {

				// Always remove the loading flag and class.
				this.setLoading( false );
			} );
	}
}

export default ClickAndReserveForm;
